import * as React from 'react';
import { Trans } from '@lingui/macro';
import { Ramp } from '@goldwasserexchange/react-topmodel';
import { NewsLetterBoxFormSubmitButtonContainer } from './components';

export const NewsLetterBoxFormSubmitButton = () => (
  <Ramp rampName="formSubmitButtonWrapper">
    <NewsLetterBoxFormSubmitButtonContainer>
      <Trans>
        S'inscrire
      </Trans>
    </NewsLetterBoxFormSubmitButtonContainer>
  </Ramp>
);
